import { fetchQuestionListActions } from '../actions/questionListActions';
import { fetchQuestions } from '../../../api/questionsApi';
import createFetchSaga from './createFetchSaga';
function* questionListSaga() {
  const fetchQuestionListSaga = createFetchSaga(fetchQuestionListActions, fetchQuestions);
  yield* fetchQuestionListSaga();
}
export default questionListSaga;
